<template>
    <div id="app">

        <Nav v-if="$store.getUser()" :user-type="$store.getUser().type"/>

        <!-- Menu / View -->
        <b-container class="wrapper">
            <router-view />
        </b-container>

        <!-- Footer -->
        <b-container class="footer text-center">
            <p class="text-muted">
                Norskbingo Kasse <br>
                ({{$git.raw }})
            </p>
        </b-container>

    </div>
</template>




<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'


export default {
    name: 'App',
    components: {
        Nav
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>


<style lang="scss">




#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;

    min-height: 100vh;
}


.wrapper {
    padding-top: 30px;
    padding-bottom: 100px;
}
.footer {
    padding-top: 30px;
    padding-bottom: 30px;
}



#nav {
    padding: 30px;
    a {
        font-weight: bold;
        color: #2c3e50;
        &.router-link-exact-active {
            color: #C53B39;
        }
    }
}


.alert ul {
    // list-style: none;
    margin-bottom: 0;
    padding-left: 1em;
}

img {
    max-width: 100%;
}

</style>
